import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Button from "@material-ui/core/Button/Button";
import ClearAll from "@material-ui/icons/ClearAll";
import FilterListIcon from "@material-ui/icons/FilterList";
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import {_isAdmin, scrollToElement} from "../../helpers/functions";
import moment from "moment";
import CloudUpload from "@material-ui/icons/CloudUpload";
import {MOBILE_TABLE_VIEW_AMOUNT} from "../../helpers/constants";
import TablePagination from "@material-ui/core/TablePagination";
import _ from "lodash";
import SortScoreRecordsForm from './sortScoreRecordsForm';

const styles = theme => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  summaryContent: {
    flexWrap: 'wrap'
  }
});

class ScoreRecordsListMobileView extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      expanded: null,
    };

    this.scoreRecordsMobileListRef = React.createRef();

  }

  componentDidMount(){
    this.props._changeLocalState({
      key: 'rowsPerPage',
      value: MOBILE_TABLE_VIEW_AMOUNT
    })
  }

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  render() {
    const { classes, scoreRecords,  handleChangePage, handleChangeRowsPerPage, page, rowsPerPage } = this.props;
    const { expanded } = this.state;

    return (
      <div className={classes.root} ref={this.scoreRecordsMobileListRef}>
        <Typography variant="h6" id="tableTitle">
          Score Records
        </Typography>
        <div className={''}>
          <Button
            color="secondary"
            style={{paddingLeft: 0}}
            className={classes.button}
            onClick={this.props.clearFilters}
          >
            Clear filters
            <ClearAll  className={'ml-1'}/>
          </Button>
          <Button
            color="primary"
            style={{paddingLeft: 0}}
            className={classes.button}
            onClick={this.props.openScoreRecordsFilterModal}
          >
            Filter list
            <FilterListIcon className={'ml-1'}/>
          </Button>
          <Button
            color="primary"
            style={{paddingLeft: 0}}
            className={classes.button}
            onClick={this.props.openUploadModal}
          >
            {'Upload Score'}
            <CloudUpload className={'ml-1'}/>
          </Button>
        </div>
        <SortScoreRecordsForm
          {...this.props}
          initialValues={{sortBy: 'createdDate', sortOrder: 'desc'}}
        />
        {
          _.orderBy(scoreRecords, item => {
            if(this.props.mobileViewSortBy === 'email' && _isAdmin(this.props.personRoles)) {return item.person.email}
            return item[this.props.mobileViewSortBy]
          }, this.props.mobileViewSortOrder)
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map(scoreRecord => {
            return (
              <ExpansionPanel
                key={scoreRecord.id}
                expanded={expanded === scoreRecord.id}
                onChange={this.handleChange(scoreRecord.id)}
              >
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} classes={{content: classes.summaryContent}}>
                  <Typography className={classes.heading}>{scoreRecord.id}</Typography>
                  <Typography className={classes.secondaryHeading}>
                    {moment(scoreRecord.createdDate).format('DD/MM/YYYY HH:mm:ss')}
                  </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <Table >
                    <TableBody>
                      <TableRow >
                        <TableCell  component="th" scope="row">{'Id'}</TableCell>
                        <TableCell>{scoreRecord.id}</TableCell>
                      </TableRow>
                      {_isAdmin(this.props.personRoles) && (
                        <TableRow >
                          <TableCell  component="th" scope="row">{'Email'}</TableCell>
                          <TableCell>{scoreRecord.person?scoreRecord.person.email:''}</TableCell>
                        </TableRow>
                      )}
                      {_isAdmin(this.props.personRoles) && (
                        <TableRow >
                          <TableCell  component="th" scope="row">{'Department'}</TableCell>
                          <TableCell>{scoreRecord.department}</TableCell>
                        </TableRow>
                      )}
                      <TableRow >
                        <TableCell  component="th" scope="row">{'Type'}</TableCell>
                        <TableCell>{scoreRecord.type}</TableCell>
                      </TableRow>
                      <TableRow >
                        <TableCell  component="th" scope="row">{'Created Date'}</TableCell>
                        <TableCell>{moment(scoreRecord.createdDate).format('DD/MM/YYYY HH:mm:ss')}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </ExpansionPanelDetails>
                <ExpansionPanelActions>
                  {_isAdmin(this.props.personRoles) && (
                    <Button
                      size="small"
                      onClick={() => this.props._openDeleteModal(scoreRecord.id)}
                    >
                      {'Delete'}
                    </Button>
                  )}
                  <Button
                    size="small"
                    color="primary"
                    onClick={() => {this.props._openInfoModal(scoreRecord.id)}}
                  >
                    {'View'}
                  </Button>
                </ExpansionPanelActions>
              </ExpansionPanel>
            )
          })
        }
        <TablePagination
          classes={
            {
              root: classes.pager,
              toolbar: classes.pagerToolbar
            }
          }
          rowsPerPageOptions={[]}
          labelRowsPerPage={''}
          component="div"
          count={scoreRecords.length}
          rowsPerPage={rowsPerPage}
          page={page}
          backIconButtonProps={{
            'aria-label': 'Previous Page',
          }}
          nextIconButtonProps={{
            'aria-label': 'Next Page',
          }}
          onChangePage={(evt, page) => {
            scrollToElement(this.scoreRecordsMobileListRef.current)
            handleChangePage(evt, page);
          }}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </div>
    );
  }
}

ScoreRecordsListMobileView.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ScoreRecordsListMobileView);



// WEBPACK FOOTER //
// ./src/components/scoreRecords/scoreRecordsListMobileView.js